module.exports = __webpack_public_path__ + "img/accessible-seat.8b92eb49.svg";